import { Button } from 'components'
import React from 'react'

const Join = () => {
  return (
    <section className="bg-gray-200">
      <div className="max-w-4xl mx-auto px-4 py-8 sm:px-6 lg:max-w-screen-2xl lg:px-8 space-y-2 w-full">
        <h3 className="text-3xl font-medium">
          Have Doubts 🙋 or Questions❓❓
        </h3>
        <div className="gap-3 md:space-y-0 flex flex-col md:flex-row items-start md:items-center justify-between">
          <p className="text-base md:text-lg lg:text-xl">
            One of our CoFounders will be live every weekday at 7 pm to resolve
            all your doubts. Join the session today.
          </p>
          {/* <a
            target="_blank"
            href="https://lu.ma/event/evt-lANbY696q4TwWPN"
            data-luma-action="checkout"
            className="w-fit"
            data-luma-event-id="evt-lANbY696q4TwWPN"
            rel="noreferrer">
            <Button>Join Session</Button>
          </a> */}
          <Button disabled={true}>Join Session</Button>
        </div>
      </div>
    </section>
  )
}

export default Join
